<nav>
    <div class="text-red-400 h-32 flex justify-start items-center ml-4 cursor-pointer">
        <img src="icons/arrow.svg" alt="arrow_back" class="h-8 pr-4 sm:h-auto">
        <a href="https://teraszarnyekolok.hu" class="no-underline">
            <p class="text-2xl sm:text-2xl text-white font-semibold hover:text-red-600 transition duration-200">
                Vissza a főoldalra
            </p>
        </a>
    </div>
</nav>